export default {
  signUpSuccess: 'okay, you\re in!',
  signUpFailure: 'email may be taken, or passwords don\'t match.',
  signInSuccess: 'come thru and haiku',
  signInFailure: 'is it really you? check your email or password again for me',
  signOutSuccess: 'come back pls 🥺',
  changePasswordSuccess: 'you changed on me',
  changePasswordFailure: 'maybe you typed your old password wrong. try that again',
  haikuCreateSuccess: 'such a beauty',
  haikuCreateFailure: 'oh no, here is what happened: ',
  haikuIndexSuccess: 'look at all those haikus',
  haikuIndexFailure: 'can\t get all of them for you ',
  haikuShowSuccess: 'fetching just the one for you',
  haikuShowFailure: 'cannot display',
  haikuUpateSuccess: 'okurrrr, we made some edits',
  haikuUpdateFailure: 'cannot update for you, try that again'
}



// WEBPACK FOOTER //
// ./src/components/AutoDismissAlert/messages.js